import { render, staticRenderFns } from "./PlayerRegattasTable.vue?vue&type=template&id=163ccf2e&scoped=true&"
import script from "./PlayerRegattasTable.vue?vue&type=script&lang=js&"
export * from "./PlayerRegattasTable.vue?vue&type=script&lang=js&"
import style0 from "./PlayerRegattasTable.vue?vue&type=style&index=0&id=163ccf2e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "163ccf2e",
  null
  
)

export default component.exports